import { render, staticRenderFns } from "./SearchResultsProducts.vue?vue&type=template&id=bb4abe80&"
import script from "./SearchResultsProducts.vue?vue&type=script&lang=js&"
export * from "./SearchResultsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports